import {$clientApi} from "../http";
import {IGeneralSettings} from "../models/GeneralSettings";

class GeneralSettingsServiceClass {

    async getGeneralSettings() {
        return await $clientApi.get<IGeneralSettings>(`api/website-integration/general-settings`)
    }

}

export const GeneralSettingsService = new GeneralSettingsServiceClass();